import React from "react";
import cx from "classnames";
import styles from "./button.module.scss";

export const Button = ({ text, icon, handleButtonClick, className }) => {
  return (
    <button className={cx(styles.button, className)} onClick={handleButtonClick}>
      <i className={icon} />
      {text}
    </button>
  );
};

export default Button;
